import type { PaperOrientation, PaperSize } from "./types.js";

/** DIN A & US paper presets. All dimensions are at portrait orientation. */
export const PAPER_A5: PaperSize = { id: "A5", widthMm: 148, heightMm: 210 };
export const PAPER_A4: PaperSize = { id: "A4", widthMm: 210, heightMm: 297 };
export const PAPER_A3: PaperSize = { id: "A3", widthMm: 297, heightMm: 420 };
export const PAPER_A2: PaperSize = { id: "A2", widthMm: 420, heightMm: 594 };
export const PAPER_A1: PaperSize = { id: "A1", widthMm: 594, heightMm: 841 };
export const PAPER_A0: PaperSize = { id: "A0", widthMm: 841, heightMm: 1189 };
export const PAPER_LETTER: PaperSize = {
  id: "Letter",
  widthMm: 215.9,
  heightMm: 279.4,
};
export const PAPER_LEGAL: PaperSize = {
  id: "Legal",
  widthMm: 215.9,
  heightMm: 355.6,
};
/** 16:9 landscape — handy for screen-friendly exports / slides. */
export const PAPER_16_9: PaperSize = {
  id: "16:9",
  widthMm: 254,
  heightMm: 143,
};

export const PAPER_PRESETS: readonly PaperSize[] = [
  PAPER_A5,
  PAPER_A4,
  PAPER_A3,
  PAPER_A2,
  PAPER_A1,
  PAPER_A0,
  PAPER_LETTER,
  PAPER_LEGAL,
  PAPER_16_9,
];

export function paperById(id: string): PaperSize | undefined {
  return PAPER_PRESETS.find((p) => p.id === id);
}

/** Effective width × height (mm) for the chosen orientation. */
export function paperDimsMm(
  paper: PaperSize,
  orientation: PaperOrientation,
): { wMm: number; hMm: number } {
  if (orientation === "landscape") {
    return { wMm: paper.heightMm, hMm: paper.widthMm };
  }
  return { wMm: paper.widthMm, hMm: paper.heightMm };
}

/** Convert mm → PDF points (1 pt = 1/72 in, 1 in = 25.4 mm). */
export const MM_TO_PT = 72 / 25.4;

/** Convert mm → CSS pixels at the given pixelRatio (96 dpi base). */
export function mmToPx(mm: number, pixelRatio: number): number {
  // 96 css px = 25.4 mm, scaled by pixelRatio for retina/print.
  return Math.round((mm * 96 * pixelRatio) / 25.4);
}
